
import { Grid, Typography, Paper, Box } from '@mui/material'
import React from 'react'
import WellnessScore from '../WellnessScore'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import HealthAgeAverageAge from '../HealthAgeAverageAge'
/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "10",
    "Visible": "1",
    "Label": "",
    "ComponentType": "OWS AND HEALTH AGE",
    "OWS": {
        "Visible": "1",
        "Label": "Your Overall Wellness Score",
        "Value": "45",
        "ValueGrade": "2"
    },
    "HealthAge": {
        "CurrentLabel": "Health Age",
        "CurrentValue": "19.9",
        "AchievableLabel": "Achievable Health Age",
        "AchievableValue": "17.5"
    }
},
*/


const HealthAgeAvgAge = (props) => {
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    return (
        <Grid item lg={4} md={4} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }} >
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Grid
                        container
                        direction="row"
                        alignItems="top"
                        justifyContent="center"
                        spacing={2}
                    >
                        <Grid item xs={12} mb={2}>
                            <Typography variant="body2" fontWeight="bold" align="center">{props.component.HealthAgeLabel}</Typography>
                        </Grid>
                        <Grid item xs={8} >
                            <Box sx={{ maxWidth: "200px" }}>
                                <HealthAgeAverageAge OWSText={'test'} CurrentOWSValue={Math.floor(props.component.HealthAgeValue)} />
                            </Box>
                        </Grid>
                        <Grid item xs={4} >
                            <Box pt={8} pl={1}>

                                <Typography variant="body1">{props.component.AvgAgeLabel}</Typography>
                                <Typography variant="caption">{Math.floor(props.component.AvgAgeValue)}</Typography>
                            </Box>
                        </Grid>

                    </Grid>
                </Paper>
            </motion.div>
        </Grid>

    )
}

export default HealthAgeAvgAge;